import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminUserResponse } from '@solverml/api';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnChanges {

  @Input() users: AdminUserResponse[] | null = [];
  @Output() userSelected = new EventEmitter<AdminUserResponse | null>();

  public allUsers: AdminUserResponse[] = [];
  public filteredUsers: AdminUserResponse[] = [];
  public selectedUserId: string | null = null;

  public searchTerm: string = '';
  public activeFilter: 'todos' | 'activo' | 'no-asignado' = 'todos';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users'] && this.users) {
      this.allUsers = [...this.users];
      this.applyFilters();
    }
  }

  public setFilter(filter: 'todos' | 'activo' | 'no-asignado'): void {
    this.activeFilter = filter;
    this.applyFilters();
  }

  public applyFilters(): void {
    let users = [...this.allUsers];

    if (this.activeFilter !== 'todos') {
      users = users.filter(user => this.getUserStatus(user) === this.activeFilter);
    }

    if (this.searchTerm) {
      const lowerCaseSearch = this.searchTerm.toLowerCase();
      users = users.filter(user =>
        (user.name?.toLowerCase().includes(lowerCaseSearch)) ||
        (user.firstSurname?.toLowerCase().includes(lowerCaseSearch)) ||
        (user.email?.toLowerCase().includes(lowerCaseSearch))
      );
    }

    this.filteredUsers = users;
  }

  public selectUser(user: AdminUserResponse): void {
    this.selectedUserId = user.idHash;
    this.userSelected.emit(user);
  }

  /**
   * Devuelve el estado del usuario, que ahora viene pre-calculado desde el backend.
   * @param user El usuario a comprobar.
   */
  public getUserStatus(user: AdminUserResponse): 'activo' | 'no-asignado' {
    // Simplemente devuelve el estado que ya nos ha calculado el backend.
    // Añadimos 'no-asignado' como fallback por si acaso.
    return user.status === 'activo' ? 'activo' : 'no-asignado';
  }
}
